<template>
  <div class="sign-in">
    <div class="logo"></div>
    <vnt-button :click="login">Sign In</vnt-button>
  </div>
</template>

<script>
import { login } from '../services/auth'

export default {
  name: 'SignIn',

  methods: {
    login
  }
}
</script>

<style>
.sign-in {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}

.logo {
  background-color: #009b00;
  background-image: url('../assets/logo.svg');
  background-size: contain;
  width: 150px;
  height: 150px;
  margin-bottom: 30px;
}
</style>
